<script setup>

</script>

<template>
    <div class="container">
        <router-view />
    </div>
</template>

<style lang="scss" scoped>
.container {
    width: 100vw;
    height: 100vh;

    display: flex;
    touch-action: none;
}

.content {
    width: 100%;
    overflow: hidden;
}


.transition-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;

    background-color: rgb(0, 0, 0);

    &.v-enter-active,
    &.v-leave-active {
        transition: opacity 0.5s ease;
    }

    &.v-enter-from,
    &.v-leave-to {
        opacity: 0;
    }
}
</style>